var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var sizeScale = {
    default: 0,
    sm: 1,
    md: 2,
    lg: 3,
};
var emptyArray = Array.from(new Array(5));
function upTo(size) {
    var sizeIdx = sizeScale[size];
    return function (firstVal, secondVal) {
        return emptyArray.reduce(function (acc, _, i) {
            if (i > sizeIdx) {
                return __spreadArray(__spreadArray([], __read(acc), false), [secondVal], false);
            }
            return __spreadArray(__spreadArray([], __read(acc), false), [firstVal], false);
        }, []);
    };
}
/**
 * Returns an array with only the default breakpoint value set.
 */
export var upToDefault = upTo('default');
/**
 * Returns an array with all values up to the SM breakpoint value set.
 */
export var upToSm = upTo('sm');
/**
 * Returns an array with all values up to the MD breakpoint value set.
 */
export var upToMd = upTo('md');
/**
 * Returns an array with all values up to the LG breakpoint value set.
 */
export var upToLg = upTo('lg');
var sortCustomArray = function (a, b) {
    var _a = __read(a, 1), aKey = _a[0];
    var _b = __read(b, 1), bKey = _b[0];
    var aOrder = sizeScale[aKey];
    var bOrder = sizeScale[bKey];
    return aOrder - bOrder;
};
var reduceSizeValues = function (acc, _a, i, customSizesArr) {
    var _b;
    var _c = __read(_a, 2), key = _c[0], value = _c[1];
    var sizeIdx = sizeScale[key];
    var nextKey = (_b = customSizesArr[i + 1]) === null || _b === void 0 ? void 0 : _b[0];
    var nextSizeIdx = nextKey ? sizeScale[nextKey] : 0;
    var isFinalValue = sizeIdx === 4;
    var isLastArrValue = i === customSizesArr.length - 1;
    var isFinalValueSkipped = isLastArrValue && !isFinalValue;
    var distance = isFinalValueSkipped ? 5 - sizeIdx : nextSizeIdx - sizeIdx;
    var areNextValuesSkipped = distance > 1;
    if (areNextValuesSkipped) {
        var filledValues = Array.from(new Array(distance)).fill(value);
        return __spreadArray(__spreadArray([], __read(acc), false), __read(filledValues), false);
    }
    return __spreadArray(__spreadArray([], __read(acc), false), [value], false);
};
export var upToCustom = function (sizeOpts) {
    var initialValue = [];
    return Object.entries(sizeOpts)
        .sort(sortCustomArray)
        .reduce(reduceSizeValues, initialValue);
};
//# sourceMappingURL=index.js.map